import React from "react";
export default function FormButtonRow ({ errorCount, onCancel, onSave, onSubmit, loading }) {
  return <div>
    {typeof onSubmit === 'function' ? <button className={`btn btn-${errorCount ? 'danger' : 'primary'} float-right mr-2`} type="button" onClick={onSubmit} disabled={loading || errorCount}>Submit</button> : null}
    {typeof onSave === 'function' ? <button className={'btn btn-info float-right mr-2'} type="button" onClick={onSave} disabled={loading}>Save</button> : null}
    {typeof onCancel === 'function' ? <button className={'btn btn-secondary float-right mr-2'} type="button" onClick={onCancel} disabled={loading}>Cancel</button> : null}
  </div>
}
